import { createStoreForProduct } from './ProductStore'

export const SpecialProductStore = createStoreForProduct('specialproduct')
